"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMessengerToken = void 0;
const dixa_1 = require("./types/dixa");
// non-production token
const DEFAULT_TOKEN = '0764b17be6cd44d5a650500af4b3b489';
const PRODUCTION_TOKENS = {
    [dixa_1.DixaLanguage.en]: 'fc4bd3a31ab14b6fad25095cbe2372ae',
    en_US: '60dafdebde9b44569b3621b726a2d031',
    [dixa_1.DixaLanguage.de]: '98ab377905b74f16b7b2564768c0db58',
    [dixa_1.DixaLanguage.nl]: '77b42e747a224f659163659a4d482a9b',
    [dixa_1.DixaLanguage.es]: '526a3a0227ab46b29cbf5c7a112b24ce',
};
function getMessengerToken(language, country) {
    var _a;
    const env = (_a = process.env.NODE_ENV) !== null && _a !== void 0 ? _a : 'production';
    if (env !== 'production') {
        return DEFAULT_TOKEN;
    }
    const key = country === dixa_1.DixaCountry.US ? 'en_US' : language;
    return PRODUCTION_TOKENS[key];
}
exports.getMessengerToken = getMessengerToken;
//# sourceMappingURL=tokens.js.map